// These are the worker environments offered by the existing ACF Geolocation
// Domain field. A copied site's own URL is not a geolocation API endpoint.
const workerHosts = new Set([
  'www.aftermetoo.com',
  'dev.aftermetoo.com',
  'test.aftermetoo.com',
]);

// Legacy header controls, the relaunch header's jurisdiction selector and every
// regional article (which shows the "not your province" notice) need the location.
export const geolocationTargets = '#province-selector, .nav-utility .region-menu [data-region], input#current-province, [data-region-selector], [data-guide-region]';

export function getGeolocationEndpoint(environment, document) {
  if (!document.querySelector(geolocationTargets) || typeof environment !== 'string') return null;
  try {
    const base = new URL(environment);
    if (base.protocol !== 'https:' || !workerHosts.has(base.hostname) || base.username || base.password || base.port) return null;
    return new URL('/get-geo-info/', base).href;
  } catch (_) {
    return null;
  }
}

export function readGeolocationRegion(request) {
  if (request.status < 200 || request.status >= 300) return null;
  if (!/^application\/(?:[\w.+-]+\+)?json(?:\s*;|$)/i.test(request.getResponseHeader('Content-Type') || '')) return null;
  try {
    const region = JSON.parse(request.responseText)?.RegionCode;
    return typeof region === 'string' && /^[a-z]{2,3}$/i.test(region.trim())
      ? region.trim().toLowerCase()
      : null;
  } catch (_) {
    // Geolocation is optional. Keep the existing/manual province on failure.
    return null;
  }
}
